import { Stack, Group, Badge, Text, Code, CopyButton, ActionIcon, Tooltip, Skeleton, Alert } from '@mantine/core'
import { IconCopy, IconCheck } from '@tabler/icons-react'
import type { TgDiagnosisResponse } from '@/api/targetGroupDiagnostics'

const sevColor: Record<string, string> = { critical: 'red', warning: 'yellow', info: 'gray' }
const sevIcon: Record<string, string> = { critical: '🔴', warning: '🟡', info: 'ℹ️' }

export function TgDiagnosticsPanel({ loading, error, data }: {
  loading: boolean
  error: Error | null
  data: TgDiagnosisResponse | undefined
}) {
  if (loading) return <Skeleton height={120} mt="sm" />
  if (error) return <Alert color="red" mt="sm">Falha ao diagnosticar. Tente novamente.</Alert>
  if (!data) return null
  if (data.findings.length === 0) {
    if (!data.sg_check_available)
      return (
        <Alert color="yellow" variant="light" mt="sm">
          Cross-check de Security Group indisponível (permissões). Nenhum outro problema detectado.
        </Alert>
      )
    return <Text size="sm" c="dimmed" mt="sm">Nenhum problema detectado.</Text>
  }

  return (
    <Stack gap="sm" mt="sm">
      {!data.sg_check_available && (
        <Alert color="yellow" variant="light">
          Cross-check de Security Group indisponível (permissões); demais achados abaixo.
        </Alert>
      )}
      {data.findings.map((f, i) => (
        <Stack key={`${f.category}-${f.title}-${i}`} gap={4} p="xs" style={{ borderLeft: `3px solid var(--mantine-color-${sevColor[f.severity]}-6)` }}>
          <Group gap="xs">
            <Text size="sm" fw={600}>{sevIcon[f.severity]} {f.title}</Text>
            <Badge size="xs" variant="light" color={sevColor[f.severity]}>{f.confidence}%</Badge>
          </Group>
          <Text size="xs" c="dimmed">{f.detail}</Text>
          {f.fix_text && <Text size="xs">▸ {f.fix_text}</Text>}
          {f.fix_cli && (
            <Group gap="xs" wrap="nowrap" align="flex-start">
              <Code block style={{ flex: 1, whiteSpace: 'pre-wrap' }}>{f.fix_cli}</Code>
              <CopyButton value={f.fix_cli}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? 'Copiado!' : 'Copiar'}>
                    <ActionIcon size="sm" variant="subtle" onClick={copy}>
                      {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
                    </ActionIcon>
                  </Tooltip>
                )}
              </CopyButton>
            </Group>
          )}
        </Stack>
      ))}
    </Stack>
  )
}
